import { Grid2 as Grid, Button, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore, Delete } from '@mui/icons-material';
import { CustomControlledInput } from "./CustomControlledInput";
import CommonCard from './common_card';
import { TypographyBold } from '../style/typography';

const SuiroExtractRequiredList = ({
    suiroExtractRequiredList,
    control,
    expandedPowerplant,
    handleEditClick,
    handleCancelEdit,
    handleEditSubmit,
    openDialog,
    title,
    isDisabled
}) => {
    return (
        <Grid size={{ xs: 12 }}>
            <CommonCard
                child={
                    <Grid container spacing={3} sx={{ padding: 3 }}>
                        <Grid size={{ xs: 12 }}>
                            <TypographyBold>
                                {title}
                            </TypographyBold>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            {suiroExtractRequiredList.map((suiroExtractRequired) => (
                                <Accordion
                                    key={suiroExtractRequired.uuid}
                                    expanded={expandedPowerplant === suiroExtractRequired.uuid}
                                    onChange={() => {
                                        if (expandedPowerplant === suiroExtractRequired.uuid) {
                                            handleCancelEdit();
                                        } else {
                                            handleEditClick(suiroExtractRequired);
                                        }
                                    }}
                                    sx={{ mb: 1 }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls={`user-content-${suiroExtractRequired.uuid}`}
                                        id={`user-header-${suiroExtractRequired.uuid}`}
                                    >
                                        <div>
                                            <Typography variant="h6" component="div">
                                                {suiroExtractRequired.name}
                                            </Typography>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <form
                                            style={{ width: "100%" }}
                                            onSubmit={handleEditSubmit((data) => {
                                                openDialog('save', data.editPowerplant);
                                            })}
                                        >
                                            <Grid container spacing={2} sx={{ paddingTop: 3 }}>
                                                {/* 施設名 */}
                                                <Grid size={{ xs: 12, md: 8 }}>
                                                    <CustomControlledInput
                                                        name="editPowerplant.name"
                                                        control={control}
                                                        label="施設名"
                                                        variant="outlined"
                                                        inputProps={{ maxLength: 100 }}
                                                        disabled={true}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <CustomControlledInput
                                                        name="editPowerplant.is_suiro_extract_required"
                                                        control={control}
                                                        label="水路抜水必須"
                                                        type="checkbox"
                                                        sx={{ mt: 1 }}
                                                        disabled={isDisabled}
                                                    />
                                                </Grid>
                                                {/* ボタン類 */}
                                                <Grid
                                                    size={{ xs: 12 }}
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    gap={2}
                                                    sx={{ mt: 2 }}
                                                >
                                                    <div style={{ display: 'flex', gap: '8px', marginLeft: 'auto' }}>
                                                        {/* キャンセル */}
                                                        <Button variant="outlined" onClick={handleCancelEdit} disabled={isDisabled}>
                                                            キャンセル
                                                        </Button>
                                                        {/* 保存 */}
                                                        <Button
                                                            variant="contained"
                                                            onClick={handleEditSubmit(
                                                                (data) => { openDialog('save', data.editPowerplant); }
                                                            )}
                                                            sx={{
                                                                backgroundColor: 'rgba(124, 183, 10, 1.0)',
                                                                '&:hover': { backgroundColor: 'rgba(124, 183, 10, 0.8)' }
                                                            }}
                                                            disabled={isDisabled}
                                                        >
                                                            保存
                                                        </Button>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </Grid>
                    </Grid>
                }
            />
        </Grid>
    );
};

export default SuiroExtractRequiredList;